import React, { Component, Fragment } from 'react';
import Sticky from 'Components/Sticky';


class ContactUs extends Component {

    renderStateOptions = () => {
        return (
            <Fragment>
            <option value="0" selected="selected">---Select State---</option>
            <option value="2">Andhra pradesh</option>
            <option value="26">Arunachal pradesh</option>
            <option value="27">Assam</option>
            <option value="21">Bihar</option>
            <option value="19">Chandigarh(UT)</option>
            <option value="11">Chhattisgarh</option>
            <option value="6451">Dadra and Nagar Haveli</option>
            <option value="10">Daman and Diu(UT)</option>
            <option value="20">Delhi</option>
            <option value="7">Goa</option>
            <option value="8">Gujarat</option>
            <option value="13">Haryana</option>
            <option value="14">Himachal Pradesh</option>
            <option value="15">Jammu and Kashmir</option>
            <option value="22">Jharkhand</option>
            <option value="3">Karnataka</option>
            <option value="4">Kerala</option>
            <option value="12">Madhya Pradesh</option>
            <option value="9">Maharashtra</option>
            <option value="28">Manipur</option>
            <option value="29">Meghalaya</option>
            <option value="30">Mizoram</option>
            <option value="31">Nagaland</option>
            <option value="23">Odisha</option>
            <option value="6">Pondicherry(UT)</option>
            <option value="16">Punjab</option>
            <option value="17">Rajasthan</option>
            <option value="24">Sikkim</option>
            <option value="5">Tamil nadu</option>
            <option value="34">Telangana</option>
            <option value="32">Tripura</option>
            <option value="18">Uttar Pradesh</option>
            <option value="33">Uttarakhand</option>
            <option value="25">West bengal</option>
            </Fragment>
        )
    }

    renderCityValues = () => {
        return (
            <option>Select City</option>
        )
    }


    render() {
        return (
            <Sticky>
              <div className="pv-25 ph-30">

                <div className="termsBannerbg pv-45 ph-20 mb-50">
                    <div className="insideBanner ">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            <div className="bannerTagline">We <span className="colorYellow">Help</span> You</div>
                            <div className="taglineBottom"></div>
                            <div className="termstaglineList">Our dedicated 24x7 support team.</div>
                            <div className="termstaglineList1">Easy contact process for faster solution.</div></div>
                        <div className="col-md-2"></div>
                    </div>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="container">
                        <h3 className="headBorder">Contact us</h3><br />
                        <div className="col-lg-3 col-md-3 col-sm-3 mb-20 pl-20">
                            <span className="subheadContact">transportEG (Caliper Business Solutions Pvt Ltd)</span><br />
                            <span className="mailContact"><a href="mailto:enquire@transporteg.com">enquire@transporteg.com</a></span><br />
                            <span> <i className="icon-phone icon-phone-color"></i> 8767227722</span>
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-3" style={{display: 'none'}}>
                            <span className="subheadContact">scmEG</span><br />
                            <span className="mailContact"><a href="mailto:enquire@scmeg.com">enquire@scmeg.com</a></span><br />
                            <span> <i className="icon-phone icon-phone-color"></i> +91 - 98810 28926</span>
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-3" style={{display: 'none'}}>
                            <span className="subheadContact">warehouseEG</span><br />
                            <span className="mailContact"><a href="mailto:enquire@warehouseeg.com">enquire@warehouseeg.com</a></span><br />
                            <span> <i className="icon-phone icon-phone-color"></i> +91 - 98810 28106</span>
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-3" style={{display: 'none'}}>
                            <span className="subheadContact">shippingEG</span><br />
                            <span className="mailContact"><a href="mailto:enquire@shippingeg.com">enquire@shippingeg.com</a></span><br />
                            <span> <i className="icon-phone icon-phone-color"></i> +91-022-41230727</span>
                        </div>
                    </div>

                    <div className="container mb-10">
                        <div className="col-lg-12 mapBG">
                            <div className="col-lg-3">
                                <div className="addressDiv bangalore-addrss">
                                    <h3>Bangalore Office</h3>
                                    <span className="logoTextAddress"> Caliper Business Solutions Pvt Ltd
                                        Cowrks,</span><br />
                                    RMZ Infinity, Ground Floor,<br />
                                    # 3, Old Madras Road,
                                    Bennigana Halli,<br />
                                    Bangalore – 560016
                                    Karnataka, India. <br /><br />

                                    <span style={{display: "none"}}><a href="#" title="Google Plus"><i className="icon-google-plus gplusIcon"></i></a></span>
                                    <span style={{display: "none"}}><a href="#" title="LinkedIn"><i className="icon-linkedin linkedIN"></i></a></span>
                                </div>
                            </div>
                        </div>
                     </div>

                    <div className="container mb-10">
                        <div className="col-lg-12 mapBG">
                            <div className="col-lg-3">
                                <div className="addressDiv">
                                    <h3>Mumbai Office</h3>
                                    <span className="logoTextAddress"> Caliper Business Solutions Pvt. Ltd.</span><br />
                                    T-161, Tower No.10, 6th Floor,<br />
                                    ITC Park, CBD Belapur Station,<br />
                                    Navi Mumbai 400614 <br /><br />

                                    <span style={{display: "none"}}><a href="#" title="Google Plus"><i className="icon-google-plus gplusIcon"></i></a></span>
                                    <span style={{display: "none"}}><a href="#" title="LinkedIn"><i className="icon-linkedin linkedIN"></i></a></span>
                                </div>
                            </div>

                            <div className="col-lg-7">
                                
                            </div>
                        </div>
                    </div>

                    {/*<div className="container">
                        <h3 className="headBorder">Drop your query, our team will revert back to you shortly.</h3><br />
                        <div className="col-lg-3"></div>
                        <div className="wt-450 whoyouareDiv alignCenter">
                            <span className="who">Who you are </span><table id="contactusForm:paymentTerms" className="contactRadio">
                            <tbody><tr>
                                <td><input type="radio" name="contactusForm:paymentTerms" id="contactusForm:paymentTerms:0" value="Service Seeker" /><label htmlFor="contactusForm:paymentTerms:0"> Service Seeker</label></td>
                                <td><input type="radio" name="contactusForm:paymentTerms" id="contactusForm:paymentTerms:1" value="Service Provider" /><label htmlFor="contactusForm:paymentTerms:1"> Service Provider</label></td>
                                <td><input type="radio" name="contactusForm:paymentTerms" id="contactusForm:paymentTerms:2" value="3PL" /><label htmlFor="contactusForm:paymentTerms:2"> 3PL</label></td>
                            </tr></tbody></table>
                        </div>
                    </div>*/}

                    {/*<div class="container paddingNone">
                        <div class="col-lg-12 contactDiv paddingNone">
                            <div className="flex fle-between mb-10 mt-10"> 
                                <div class="wt-450"><label>Name</label><input id="contactusForm:name" type="text" name="contactusForm:name" style={{width: "40%!important"}} />
                                </div>

                                <div class="wt-450"><label>Country</label><select name="contactusForm:j_idt46" size="1" style={{width: "40%!important" }}>  <option value="0" selected="selected">---Select Country---</option>
                                    <option value="32">India</option>
                                    </select>
                                </div>
                            </div>

                            <div className="flex fle-between mb-10 mt-10"> 
                                <div class="wt-450"><label>Email</label><input id="contactusForm:email" type="text" name="contactusForm:email" style={{width: "40%!important"}} />
                                </div>                      

                                <div class="wt-450"><label>State</label><select id="contactusForm:stateId" name="contactusForm:stateId" size="1" style={{width:"40%!important"}}>   
                                    {this.renderStateOptions()}
                                    </select>
                                </div>
                            </div>

                            <div className="flex fle-between mb-10 mt-10"> 
                                <div class="wt-450"><label>Contact No.</label><input id="contactusForm:contact" type="text" name="contactusForm:contact" maxlength="10" style={{width:"40%!important"}} />
                                </div>

                                <div class="wt-450"><label>City</label><select id="contactusForm:cityId" name="contactusForm:cityId" size="1" style={{ width:"40%!important"}}>    
                                    {this.renderCityValues()}
                                    </select>
                                </div>
                            </div>

                            <div className="flex fle-between mb-10 mt-10"> 
                                <div class="col-lg-12"><label class="labelSpecial">Query</label><textarea id="contactusForm:query" name="contactusForm:query"></textarea>
                                </div>
                            </div>

                            <div class="btn-submit-div"><input type="submit" name="contactusForm:j_idt62" value="Submit Query" style={{marginRight: "10px"}} class="btn-submit" /><br /><span style={{color: "red"}}></span></div>
                        </div>
                    </div>*/}

                </div>
                <div className="footer flex flex-center ">
                    <div className="fs-12 mt-10 mb-10 ml-15 mr-15 tCenter fSemibold curP" onClick={() => this.props.history.push('/infringementPolicy')}>IP & Infringement Policy</div>
                    <div className="fs-12 mt-10 mb-10 ml-15 mr-15 tCenter fSemibold curP" onClick={() => this.props.history.push('/privacyPolicy')}>Privacy Policy</div>
                    <div className="fs-12 mt-10 mb-10 ml-15 mr-15 tCenter fSemibold curP" onClick={() => this.props.history.push('/termsOfUse')}>Terms Of Use</div>
                    <div className="fs-12 mt-10 mb-10 ml-15 mr-15 tCenter fSemibold curP" onClick={() => this.props.history.push('/liabilityDisclaimer')}>Liability Disclaimer</div>
                    <div className="fs-12 mt-10 mb-10 ml-15 mr-15 tCenter fSemibold curP" onClick={() => this.props.history.push('/contactUs')}>Contact Us</div>
                </div>
              </div>
            </Sticky>
        );
    }
    
}

export default ContactUs;





